import React, { Component } from 'react'
import axios from 'axios'
import PopForm from '../../Components/Demand/PopForm'
import DemandItem from '../../Components/Demand/DemandItem'
import FilterList from '../../Components/Demand/FilterList'
import Auth from '../../Modules/Auth'
import './DemandListPage.scss'
import { withCookies, Cookies } from 'react-cookie'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
import MetaTags from 'react-meta-tags'
import { RoleType } from '../../Components/Commons/Utils'

class DemandListPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedStatus: 'ALL',
            list: null,
            fliterList: null,
        }
    }

    componentDidMount() {
        this.loadList()
    }

    loadList = () => {
        const { cookies } = this.props
        axios
            .get(`${BACKEND_HOST}/rfis/?project_id=${cookies.get('project')}&resReq=REQ`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res.data)
                this.setState({ list: res.data.data, fliterList: res.data.data })
                //console.log(this.state.list)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    filterStatus = (status) => {
        if (status === 'ALL') {
            this.setState({ selectedStatus: status, fliterList: this.state.list })
        } else {
            const List = this.state.list.filter((data) => data.status === status)
            this.setState({ selectedStatus: status, fliterList: List })
        }
    }

    addItem = (addItem) => {
        const list = this.state.list
        list.unshift({ ...addItem })
        this.setState({ list, fliterList: list })
    }

    renderList = () => {
        const List = this.state.fliterList.map((item) => {
            return <DemandItem item={item} key={item._id} />
        })
        return List
    }

    render() {
        //console.log(this.state.fliterList)

        if (this.state.list) {
            return (
                <div>
                    <MetaTags>
                        <title>투명한 집짓기 하우스플래너 - 하우스플래너는 건축주의 목소리가 중심이 됩니다.</title>
                    </MetaTags>
                    <HeaderMenu />
                    <div className="section_wrap section_wrap_menu">
                        <div className="demand_list_wrap">
                            <div className="demand_list_top">
                                <div className="common_wrap">
                                    <h1>건축주의 요청</h1>
                                    <h2>
                                        설계팀이나 시공사, 현장 담당자 등 관계자에게 작업을 요청할 수 있는 공간입니다.
                                        <br />
                                        내가 요청한 작업의 처리 결과를 확인할 수 있습니다.
                                    </h2>
                                    {/* {(this.props.cookies.get('project_role') === RoleType.CLIENT ||
                                        this.props.cookies.get('project_role') === RoleType.ADMIN) && ( */}
                                    <PopForm addItem={this.addItem} />
                                    {/* )} */}
                                </div>
                            </div>
                            <div className="demand_list_bottom common_wrap">
                                <FilterList
                                    list={this.state.list}
                                    onChangeStatus={this.filterStatus}
                                    selectedStatus={this.state.selectedStatus}
                                />
                                <div className="list_title pc_v_impo">
                                    <p className="title">요청</p>
                                    <p className="name">담당자</p>
                                    <p className="date">등록일</p>
                                    <p className="status">상태</p>
                                </div>
                                <div className="list_wrap">
                                    {this.state.list.length !== 0 ? (
                                        this.renderList()
                                    ) : (
                                        <div className="no_list_wrap">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                width="55"
                                                height="63"
                                                viewBox="0 0 55 63">
                                                <defs>
                                                    <linearGradient id="c1" x1="50%" x2="0%" y1="50%" y2="100%">
                                                        <stop offset="0%" stopColor="#E1E4EA" />
                                                        <stop offset="100%" stopColor="#D6D7DB" />
                                                    </linearGradient>
                                                    <path id="b1" d="M31 0v23h23z" />
                                                    <filter
                                                        id="a1"
                                                        width="113%"
                                                        height="113%"
                                                        x="-6.5%"
                                                        y="-6.5%"
                                                        filterUnits="objectBoundingBox">
                                                        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                                                        <feGaussianBlur
                                                            in="shadowOffsetOuter1"
                                                            result="shadowBlurOuter1"
                                                            stdDeviation=".5"
                                                        />
                                                        <feColorMatrix
                                                            in="shadowBlurOuter1"
                                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                                        />
                                                    </filter>
                                                </defs>
                                                <g fill="none" fillRule="evenodd">
                                                    <path
                                                        fill="#E2E4E9"
                                                        d="M3 1h27.952L54 23.997V60a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3z"
                                                    />
                                                    <g
                                                        stroke="#F5F7FA"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth="2.4">
                                                        <path d="M37 32.733L17.733 52M17.733 32.733L37 52" />
                                                    </g>
                                                    <g transform="translate(0 1)">
                                                        <use fill="#000" filter="url(#a1)" xlinkHref="#b1" />
                                                        <use fill="url(#c1)" xlinkHref="#b1" />
                                                    </g>
                                                </g>
                                            </svg>
                                            <p>아직 등록된 내용이 없습니다.</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div>
                <HeaderMenu />
                <div className="section_wrap" />
            </div>
        )
    }
}

export default withCookies(DemandListPage)



// WEBPACK FOOTER //
// ./Src/Containers/Demand/DemandListPage.js